import React from 'react';
import { OnlineVideo, Card } from 'components';
import { IWebRTCReceiverType, Unread, VideoType } from '_helpers';
import { ExamApplicationStatus } from 'components/enums';
import { IExamApplication } from 'components/models';
import styles from './VideoTab.module.scss';

const VideoTab = ({
    examApplications,
    webRTC,
    switchVideoType,
    unread,
    onPreviewClick,
}: IProps) => (
        <Card
          title="Проведение экзамена"
          category="При проведении экзамена необходимо осуществлять контроль над соискателями"
          withoutBorder
        >
            <section className={styles.videoTab}>
                {examApplications.map(applicant => ((
                    applicant.status === ExamApplicationStatus.IsPassing
                    || applicant.status === ExamApplicationStatus.AdmittedToExam
                    || applicant.status === ExamApplicationStatus.WaitingForOnlineAccepting) ? (
                    <OnlineVideo
                      haveNewAlerts={!!(unread && unread[applicant.applicantId] && unread[applicant.applicantId].logs)}
                      haveNewMessages={!!(unread && unread[applicant.applicantId] && unread[applicant.applicantId].messages)}
                      key={`onlineVideo_${applicant.applicantId}`}
                      onPreviewClick={onPreviewClick}
                      onSwitch={switchVideoType}
                      applicantFullName={applicant.applicantFullName}
                      applicantId={applicant.applicantId}
                      className={styles.video}
                      processing={!webRTC || (webRTC[applicant.applicantId] && !webRTC[applicant.applicantId].connected)}
                      videoStream={webRTC && webRTC[applicant.applicantId] ? webRTC[applicant.applicantId].receiver.video.remoteStream : undefined}
                      videoType={webRTC && webRTC[applicant.applicantId] ? webRTC[applicant.applicantId].type : undefined}
                      haveStream={webRTC && webRTC[applicant.applicantId] ? webRTC[applicant.applicantId].receiver.video.haveVideoStream : undefined}
                      examSessionReadyStatus={applicant.examSessionReadyStatus}
                      withoutFullScreen
                    />
                ) : null))}
            </section>
        </Card>
    );

export default VideoTab;

interface IProps {
    examApplications: IExamApplication[];
    webRTC?: IWebRTC;
    unread?: { [id: string]: Unread };
    onPreviewClick?: (applicationId: string) => void;
    switchVideoType?: (videoType: VideoType, applicantId: string) => void;
}

interface IWebRTC {
    [id: string]: {
        receiver: IWebRTCReceiverType;
        connected: boolean;
        type: VideoType;
    };
}
